/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetailsStats_user" | "ContactDealerInlineForm_user" | "PdpSharedSellerTabsVariant_user" | "PdpSharedCallDealerCta_user">;
    readonly " $refType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$data = PdpRespDealerDetails_user;
export type PdpRespDealerDetails_user$key = {
    readonly " $data"?: PdpRespDealerDetails_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetailsStats_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user",
      "args": null
    }
  ]
};
(node as any).hash = '70f70df30d188958adaa9aaf397b420e';
export default node;
